export default {
	format: (input, e) => {
		if (['keyup', 'blur', 'mounted'].includes(e.type)) {
			console.log(e.type);

			let input_val = input.value.replace(/\D/g, '');
			input.value = input_val;

			let caret_pos = input.selectionStart;
			if (caret_pos > input_val.length) {
				caret_pos = input_val.length;
			}
			input.setSelectionRange(caret_pos, caret_pos);
		}
	},
	parse: val => {
		const formattedVal = val.replace(/\D/g, '');
		return formattedVal;
	}
};
